import {  createContext, useContext, useState } from "react";

export const DEFAULT_CONFERENCE_ID = 1;

const StateContext = createContext ({
    user : null , 
    token : null, 
    notifications : null , 
    data : [] , 
    setData : () =>{ } , 
    API : "https://api.anbar-bcs.org" , 
    LastSelectedConference : DEFAULT_CONFERENCE_ID , 
    setLastSelectedConference :()=>{}, 
    SetNotification:()=>{},
    setUser : () =>{} , 
    setToken : ()=>{} 
})

export const ContextProvider = ({children})=>{

    const userinlocal = localStorage.getItem("ADMINUSER")
const [user, _setUser] = useState( userinlocal ? JSON.parse(userinlocal) : {name : "username"} );
const [data , setData] = useState ([]) ; 

const [token , _setToken] = useState (localStorage.getItem('Admin_ACCESS_TOKEN')) ; 
const [API , setAPI] = useState('https://api.anbar-bcs.org') ; 
const [notifications , SetNotifications] = useState ([]) ; 
const [LastSelectedConference , setLastSelectedConference] = useState(DEFAULT_CONFERENCE_ID) ; 
const SetNotification  =(msg , type   ) =>{ 
    const not_id =notifications.length + 1  ; 
    const noti ={message : msg , type : type , id : not_id} ;  
    
    SetNotifications ( old => [ ...old, noti]) ; 
    console.log(notifications) ;
    setTimeout(() =>{ 
        SetNotifications((notifications) =>
        notifications.filter((Notification) => Notification.id !== not_id))
    }, 4000
    );

}

const setToken = (token)=>{
    _setToken(token) ; 
    if (token) {
        localStorage.setItem('Admin_ACCESS_TOKEN' , token) ; 
    }else {
        localStorage.removeItem('Admin_ACCESS_TOKEN') ; 
    }
}
const setUser = (user)=> {
    _setUser (user) ; 
    if (user) {
        if (user)
    localStorage.setItem('ADMINUSER', JSON.stringify(user));
    }else localStorage.removeItem("ADMINUSER") ; 
}
    return (
        <StateContext.Provider value={ {
            user , 
            token, 
            data, 
            setData , 
            setUser , 
            setToken , 
            API,
            LastSelectedConference, 
            notifications,
            SetNotification , 
            setLastSelectedConference
         }} >
          {children}
        </StateContext.Provider>
    )
}

export  const useStateContext = () => useContext(StateContext);
